import React, { ReactElement, useState } from 'react';
import {
  Breadcrumbs,
  HiddenPriorityTitle,
  homeBreadcrumb,
  Message,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import routes from '../../routing/routes';
import Layout from '../Layout';
import { useClient } from '../../context/ClientStatusContext';
import InformacieOCookies from '../../module/InformacieOCookies';
import { getInformacieOCookies } from '../../client/informacieOCookiesClient';

const InformacieOCookiesPage = (): ReactElement => {
  const {
    data,
    status,
  } = useClient(
    () => getInformacieOCookies(),
  );
  const [displayError, setDisplayError] = useState(true);

  return (
    <Layout>
      <HiddenPriorityTitle>Informácie o cookies</HiddenPriorityTitle>
      <Breadcrumbs
        routeList={[
          homeBreadcrumb(process.env.REACT_APP_STATICKY_OBSAH_URL as string),
          {
            to: routes.informacieOCookies.to,
            heading: routes.informacieOCookies.name,
          },
        ]}
      />
      <Loader loading={status.loading}>
        {(status.responseCode && status.responseCode > 399) ? (
          <>
            {displayError && (
              <Message
                type="error"
                onClear={() => setDisplayError(false)}
                headingSize="m"
              >
                Nepodarilo sa načítať informácie o cookies.
              </Message>
            )}
          </>
        )
          : (
            <InformacieOCookies
              text={data}
            />
          )}
      </Loader>
    </Layout>
  );
};

export default InformacieOCookiesPage;
